module.exports = __webpack_public_path__ + "static/media/excel-icon.add6b0e4.ico";